import React, { useState } from "react";
import { Box, Container, Typography, Tabs, Tab } from "@mui/material";
import WorkHourTrackingForm from "./WorkHourTrackingForm";
import ScaffoldTimeTracking from "../scaffoldTimeTracking/ScaffoldTimeTracking";
import AdminWeeklyOverview from "../employeeTimeWeeklyOverview/AdminWeeklyOverview";
import UserWeeklyOverview from "../employeeTimeWeeklyOverview/UserWeeklyOverview";
import AdminTimeLogManagement from "../adminTimeLogManagement/AdminTimeLogManagement";
import { useSelector } from "react-redux";
import AdminManagementIndex from "../adminTimeLogManagement/AdminManagementIndex";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function WorkHourTrackingIndex() {
  const userType = useSelector((state) => state?.auth?.loggedInUser?.type);
  const isAdmin = userType == 0;

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabs = isAdmin
    ? [
        {
          label: "Admin Log Management",
          component: <AdminManagementIndex />,
        },
      ]
    : [
        { label: "Timetable Overview", component: <UserWeeklyOverview /> },
      ];

  return (
    <Container maxWidth="90vw" minHeight="90vh" >
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="time tracking tabs"
            variant="fullWidth"
          >
            {tabs.map((tab, index) => (
              <Tab key={index} label={tab.label} {...a11yProps(index)} />
            ))}
          </Tabs>
        </Box>

        {tabs.map((tab, index) => (
          <TabPanel key={index} value={value} index={index}>
            {tab.component}
          </TabPanel>
        ))}
      </Box>
    </Container>
  );
}
